var _circle, _line, _line2, _line3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.141,
    cy: 16.9628,
    r: 15.271,
    stroke: "black",
    strokeWidth: 1.7401
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.0542,
    y1: 17.5828,
    x2: 31.2283,
    y2: 17.5828,
    stroke: "black",
    strokeWidth: 1.7401
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 8.69432,
    y1: 4.21925,
    x2: 22.156,
    y2: 17.6809,
    stroke: "black",
    strokeWidth: 1.7401
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 7.94798,
    y1: 17.6809,
    x2: 21.4096,
    y2: 31.1426,
    stroke: "black",
    strokeWidth: 1.7401
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.33c5470c9d46e7413a605dfbd5da8511.svg";
export { ForwardRef as ReactComponent };